import { render, staticRenderFns } from "./Alibaba-received-myself.vue?vue&type=template&id=1363ed1c&scoped=true&"
import script from "./Alibaba-received-myself.vue?vue&type=script&lang=js&"
export * from "./Alibaba-received-myself.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-received-myself.vue?vue&type=style&index=0&id=1363ed1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363ed1c",
  null
  
)

export default component.exports